import { expandHighlight, moveHighlight } from './utils';
import { $actionEvent } from '@/actions/actionEvent';
import { editCellPos } from '@/components/RichTextEditor';
import { $sheet } from '@/components/SheetView';
import { $highlight, clearSelections } from '@/components/selection';
import { Vector2 } from '@/utils/vec';

export type Shortcuts = Record<string, () => void>;

export const allShortcuts: Shortcuts = {
  ArrowUp: () => moveHighlight(Vector2.up),
  ArrowDown: () => moveHighlight(Vector2.down),
  ArrowLeft: () => moveHighlight(Vector2.left),
  ArrowRight: () => moveHighlight(Vector2.right),
  ShiftArrowUp: () => expandHighlight(Vector2.up),
  ShiftArrowDown: () => expandHighlight(Vector2.down),
  ShiftArrowLeft: () => expandHighlight(Vector2.left),
  ShiftArrowRight: () => expandHighlight(Vector2.right),
  Backspace: () => $actionEvent.emit('delete'),
  Delete: () => $actionEvent.emit('delete'),
  Tab: () => moveHighlight(Vector2.right),
  ShiftTab: () => moveHighlight(Vector2.left),
  Enter: () => moveHighlight(Vector2.down),
  ShiftEnter: () => moveHighlight(Vector2.up),
  Escape: () => $actionEvent.emit('escape'),
};

export function getShortcutKey(e: KeyboardEvent | React.KeyboardEvent): string {
  const { key, altKey, ctrlKey, metaKey, shiftKey } = e;
  let shortcut = key;

  if (metaKey) shortcut = 'Meta' + shortcut;
  if (shiftKey) shortcut = 'Shift' + shortcut;
  if (altKey) shortcut = 'Alt' + shortcut;
  if (ctrlKey) shortcut = 'Ctrl' + shortcut;

  return shortcut;
}

export function tryShortcut(
  e: KeyboardEvent | React.KeyboardEvent,
  shortcuts: Shortcuts,
): boolean {
  const shortcut = getShortcutKey(e);
  const action = shortcuts[shortcut];
  if (action) {
    e.preventDefault();
    action();
    return true;
  }
  return false;
}

function onKeyDown(e: KeyboardEvent) {
  if (tryShortcut(e, allShortcuts)) return;
  if (e.key.length > 1 || e.altKey || e.metaKey || e.ctrlKey) return;

  const sheet = $sheet.get();
  if (!sheet) return;
  const highlight = $highlight.get();
  editCellPos(highlight, sheet);
  clearSelections();
}

window.addEventListener('keydown', onKeyDown);
